var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrderLack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE8\xAE\xA2\xE5\x8D\x95\xE7\xBC\xBA\xE7\x9C\x81"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\xE7\xBC\x96\xE7\xBB\x84"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE7\xBC\x96\xE7\xBB\x84 11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE7\xBC\x96\xE7\xBB\x84 7\xE5\xA4\x87\xE4\xBB\xBD 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE7\xBC\x96\xE7\xBB\x84 2\xE5\xA4\x87\xE4\xBB\xBD"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE7\xBC\x96\xE7\xBB\x84 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE7\x9F\xA9\xE5\xBD\xA2",
    d: "M14.4082 15.376C14.4082 12.6146 16.6468 10.376 19.4082 10.376H65.2688C68.0302 10.376 70.2688 12.6146 70.2688 15.376V22.8648C70.2688 23.4171 69.8211 23.8648 69.2688 23.8648H14.4082V15.376Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE7\x9F\xA9\xE5\xBD\xA2_2",
    d: "M14.4082 15.376C14.4082 12.6146 16.6468 10.376 19.4082 10.376H62.758V64.8978C62.758 67.6593 60.5194 69.8979 57.758 69.8979H14.4082V15.376Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE5\xBD\xA2\xE7\x8A\xB6\xE7\xBB\x93\xE5\x90\x88",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6656 69.9892C55.0601 69.8207 53 67.6977 53 65.1035V61H6.08911C6.03989 61 6 61.0399 6 61.0891C6 66.0105 9.98954 70 14.9109 70H57.4286C57.5085 70 57.5875 69.9964 57.6656 69.9892Z",
    fill: "#E1E1E1"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "\xE7\x9F\xA9\xE5\xBD\xA2\xE5\xA4\x87\xE4\xBB\xBD 12",
    x: 40,
    y: 30,
    width: 13,
    height: 2,
    rx: 1,
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\xE7\x9F\xA9\xE5\xBD\xA2\xE5\xA4\x87\xE4\xBB\xBD 19",
    width: 8,
    height: 2,
    rx: 1,
    transform: "matrix(-1 0 0 1 31 30)",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\xE7\x9F\xA9\xE5\xBD\xA2\xE5\xA4\x87\xE4\xBB\xBD 18",
    x: 33,
    y: 30,
    width: 8,
    height: 2,
    rx: 1,
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\xE7\x9F\xA9\xE5\xBD\xA2\xE5\xA4\x87\xE4\xBB\xBD 17",
    x: 36,
    y: 22,
    width: 17,
    height: 2,
    rx: 1,
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\xE7\x9F\xA9\xE5\xBD\xA2\xE5\xA4\x87\xE4\xBB\xBD 20",
    width: 10,
    height: 2,
    rx: 1,
    transform: "matrix(-1 0 0 1 33 22)",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\xE7\x9F\xA9\xE5\xBD\xA2\xE5\xA4\x87\xE4\xBB\xBD 16",
    x: 22,
    y: 46,
    width: 13,
    height: 2,
    rx: 1,
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\xE7\x9F\xA9\xE5\xBD\xA2\xE5\xA4\x87\xE4\xBB\xBD 14",
    x: 38,
    y: 46,
    width: 8,
    height: 2,
    rx: 1,
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\xE7\x9F\xA9\xE5\xBD\xA2\xE5\xA4\x87\xE4\xBB\xBD 7",
    x: 22,
    y: 38,
    width: 20,
    height: 2,
    rx: 1,
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\xE7\x9F\xA9\xE5\xBD\xA2\xE5\xA4\x87\xE4\xBB\xBD 13",
    x: 44,
    y: 38,
    width: 5,
    height: 2,
    rx: 1,
    fill: "#DCDCDC"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderLack);
export default __webpack_public_path__ + "static/media/order_lack.b7c36304f670c0176525fd5b3a03bf1d.svg";
export { ForwardRef as ReactComponent };